import {
  VIEW_DAY,
  VIEW_MONTH,
  VIEW_WEEK,
  VIEW_AGENDA,
  OPTION_CHOSEN,
  SERVICE_COLOR_PALETTE,
  VIEW_WAITLIST,
} from '@/lib/consts.js'

import {
  WIDTH_MODE_SETTINGS,
  ADD_EVENT_DROPDOWN_OPENING_SOURCE,
} from '@/components/calendar/consts.js'

import {
  ERROR_MESSAGE_TYPE,
} from '@/components/calendar/composables/calendar-import/consts.js'

export const CALENDAR_SETTINGS_ANALYTICS_SCREEN_NAME = {
  SETTINGS: 'calendar_settings',
  VIEW_DROPDOWN: 'calendar_view_dropdown',
  FILTER_HIGHLIGHT: 'calendar_highlight',
  FILTER_STAFF: 'calendar_staff',
  FILTER_RESOURCES: 'calendar_resources',
  VIEW: 'calendar_view',
  APPT_LIST: 'calendar_appt_list',
  DATEPICKER: 'calendar_datepicker',
  RESOURCE_MENU: 'calendar_resource_menu',
  CALENDAR_NOTIFICATION: 'calendar_notification',
}

export const CALENDAR_EVENT_ACTIONS = {
  TODAY_CLICKED: 'today_clicked',
  JUMP_CLICKED: 'jump_clicked',
  GO_TO_SHIFTS_CLICKED: 'go_to_shifts_clicked',
  SETTINGS_CLICKED: 'settings_clicked',
  CALENDAR_IMPORTER_FILE_SELECT: 'importer_file_select',
  CALEMDAR_IMPORTER_FILE_IMPORT: 'importer_file_import',
  CALENDAR_IMPORTER_FILE_DISSMIS: 'importer_file_dismiss',
  CALENDAR_IMPORTER_EVENTS_DISCARD: 'importer_events_discard',
  CALENDAR_IMPORTER_NEED_HELP: 'importer_need_help',
  CALENDAR_IMPORTER_TUTORIAL: 'importer_tutorial',
  ARROW_CLICKED: 'arrow_clicked',
  CALENDAR_SIDEBAR_ICON_CLICKED: 'sidebar_toggle_clicked',
  CALENDAR_NOTIFICATION_ICON_CLICKED: 'show_notification_panel_clicked',
  CALENDAR_CLIENT_SEARCH_CLICKED: 'client_search_clicked',
  CALENDAR_NEW_APPOINTMENT: 'new_appt_clicked',
  CALENDAR_NEW_TIME_RESERVATION: 'add_time_reservation_clicked',
  CALENDAR_ADD_TIME_OFF: 'add_time_off_clicked',
  CALENDAR_EVENT_CARD_CHANGED: 'cal_event_card_changed',
  CALENDAR_EVENT_CARD_CHANGE_CANCELED: 'cal_event_card_change_canceled',
  CALENDAR_EVENT_CARD_CLICK: 'cal_event_card_clicked',
  NOTIFICATIONS_FILTERS_CLICKED: 'filters_clicked',
  APPT_OVERBOOKING_CONFIRMED: 'appt_overbooking_confirmed',
  APPT_OVERBOOKING_CANCELED: 'appt_overbooking_canceled',
  CALENDAR_DATA_UPDATED: 'calendar_data_updated',
}

export const CALENDAR_SETTINGS_ANALYTICS_TRANSLATED_VALUES = {
  [VIEW_DAY]: 'day',
  [VIEW_WEEK]: 'week',
  [VIEW_MONTH]: 'month',
  [VIEW_AGENDA]: 'appt_list',
  [VIEW_WAITLIST]: 'waitlist',
  [WIDTH_MODE_SETTINGS.FIT]: 'fit_on_page',
  [WIDTH_MODE_SETTINGS.FIXED]: 'full_size',
  [SERVICE_COLOR_PALETTE.VIVID]: 'vivid',
  [SERVICE_COLOR_PALETTE.PASTEL]: 'pastel',
  [OPTION_CHOSEN.DAY_VIEW]: 'day_view',
  [OPTION_CHOSEN.TIME_OFF]: 'time_off',
  [OPTION_CHOSEN.WORKING_HOURS]: 'working_hours',
  [ADD_EVENT_DROPDOWN_OPENING_SOURCE.FAB]: 'fab',
  [ADD_EVENT_DROPDOWN_OPENING_SOURCE.CALENDAR_CONTENT]: 'empty_slot',
  [ERROR_MESSAGE_TYPE.WRONG_FILE_FORMAT]: 'file_wrong_format',
  [ERROR_MESSAGE_TYPE.WRONG_FILE_SIZE]: 'file_too_large',
  [ERROR_MESSAGE_TYPE.FILE_CORRUPTED]: 'file_load_fail',
}
